import { render, staticRenderFns } from "./catDynamics.vue?vue&type=template&id=4f4543f0&scoped=true"
import script from "./catDynamics.vue?vue&type=script&lang=js"
export * from "./catDynamics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4543f0",
  null
  
)

export default component.exports